// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__heJXY","label":"Category_label__1oS2x","content":"Category_content__3BVUj","header":"Category_header__3SdPa","location":"Category_location__1C1YV"};